import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LookupReceiptSaleModal from "../../../components/Modal/LookupReceiptSaleModal";

import {
  Dashboard,
  settings,
  Product,
  Users1,
  Vehicle,
  Wrench,
  calendar,
  Employee,
  Suppliers,
  Home,
  Sales1,
  GiftCard,
  Email,
  Receiving,
  Expense,
  Places,
} from "../../../common/imagePath";
import { Link } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
import Header from "./Header";
import { checkUserPermission } from "../../../common/UserPermission";
import LookupReceiptModal from "../../../components/Modal/LookupReceiptModal";
import LookupReceiptDriverTaskModel from "../../../components/Modal/LookupReceiptDriverTaskModel";
import axios from "axios";
import config from "../../../config/config";
import { AppContext } from "../../../context/AppContext";

let PERMISSION_LOOKUPRECEIPT = "/sales-receipt";
const Sidebar = () => {
  const {
    isManageSale,
    isManagePOSSale,
    registerId,
    isManageReceiving,
    isManagePOSReceiving,
    showEmployeeRegister,
  } = useContext(AppContext);
  // const regId =  registerId || 0;
  const regId = localStorage.getItem("UserRegisterId") || 0;
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const [isSideMenu, setSideMenu] = useState("");
  const [sidepromo, setSidePromo] = useState("");
  const [pendingEcommCustomer, setPendingEcommCustomer] = useState([]);
  const [data, setData] = useState([]);
  // const [path, setPath] = useState("");
  const history = useNavigate();
  const navigate = useNavigate();

  console.log(data, "54545454545");

  useEffect(() => {
    axios
      .get(`${config.customersBaseUrl}/customers/ecommpendingcustomercount`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res.data.ResponseData, "11212121212121212");
        setPendingEcommCustomer(res.data.ResponseData[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const toggleSidebar = (value) => {
    setSideMenu(value);
  };

  // const handlepaymnetmethod = () => {

  //   let reqobj = {id:loginUserId}
  //   axios
  //     .post(
  //       `${config.accountingBaseUrl}/chartofaccounts/Paymentmethod`,
  //       reqobj,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //         },
  //       }
  //     )
  //     .then((res) => {

  //     })
  //     .catch((error) => {

  //     });
  // }

  const toggleSidebarpromo = (value) => {
    setSidePromo(value);
  };

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };

  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const pageRefresh = (url, page) => {
    history.push(`/${url}/${page}`);
    window.location.reload();
  };

  // const role = localStorage.getItem("Role");

  const location = useLocation();
  let pathname = location.pathname;
  console.log(pathname);

  useEffect(() => {
    // console.log("getUserPermission sidebar :=>", userPermission);

    // Temporary comment by Chelsi about header top menu  (29-12-2022)
    // document.querySelector(".main-wrapper").classList.remove("slide-nav");
    // document.querySelector(".sidebar-overlay").classList.remove("opened");
    // document.querySelector(".sidebar-overlay").onclick = function () {
    //   this.classList.remove("opened");
    //   document.querySelector(".main-wrapper").classList.remove("slide-nav");
    // };

    const element = document.querySelector(".main-wrapper");
    if (element !== null) {
      element.classList.remove("slide-nav");
      document.querySelector(".sidebar-overlay").classList.remove("opened");
      document.querySelector(".sidebar-overlay").onclick = function () {
        this.classList.remove("opened");
        document.querySelector(".main-wrapper").classList.remove("slide-nav");
      };
    }
  }, [pathname]);

  const redirectToreceiving = () => {
    // localStorage.setItem("receivingDraft", {openpageexpenses:true});
    localStorage.setItem("openpageexpenses", true);
    // navigate("/manage-receiving");
    // return ("/manage-receiving");
  };

  console.log(isSideMenu);
  const handleLinkClickManageReceiving = () => {
    const clear = location.pathname.split("/");
    if (clear?.length === 3 && clear[1] === "manage-receiving") {
      // console.log(location.pathname, clear, "hasParameter");
      // localStorage.removeItem("receivingDraft");
      navigate(
        isManageSale == 1
          ? "/manage-receiving"
          : isManagePOSSale == 1
          ? "/pos-receiving"
          : "#"
      );
      // navigate("/manage-receiving");
      window.location.reload();
    }
  };

  const handleLinkClickManageReceivingExpence = () => {
    const clear = location.pathname.split("/");
    if (clear?.length === 3 && clear[1] === "Expense") {
      // console.log(location.pathname, clear, "hasParameter");
      // localStorage.removeItem("receivingDraft");
      navigate("/Expense");
      window.location.reload();
    }
  };

  const handleLinkClickManageSales = () => {
    const clear = location.pathname.split("/");
    if (clear?.length === 3 && clear[1] === "manage-sales") {
      // console.log(location.pathname, clear, "hasParameter");
      // localStorage.removeItem("receivingDraft");
      // navigate("manage-sales");
      window.location.reload();
    }
  };

const handleListData = () => {
  axios
    .get(
        `${config.accountingBaseUrl}/chartofaccounts/accountddl?type=5&undepositedfunds=true`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
    .then((res) => {
      const Data = res.data.ResponseData?.[0] || [];
      setData([Data]);
    })
    .catch((err) => {
      console.error("Error fetching data", err);
      setData([]); // Set to empty to prevent blank screen
    });
};


  useEffect(() => {
    handleListData();
  }, []);

  return (
    <>
      <Header />
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div
              id="sidebar-menu"
              className="sidebar-menu"
              onMouseLeave={expandMenu}
              onMouseOver={expandMenuOpen}
            >
              <ul>
                {/* <li className={`customer-dropdown-phone ${pathname.includes("pos") ? "active" : ""}`}>
                    <Link
                      to="/pos"
                      // onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img src={Users1} alt="img" style={{ width: "18px" }} /> */}

                {/* <i class="fas fa-box-open"></i>
                      <span>POS</span>
                    </Link>
                  </li> */}
                {checkUserPermission("/dashboard") ? (
                  <li
                    className={pathname.includes("dashboard") ? "active" : ""}
                  >
                    <Link
                      to="/dashboard"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img src={Dashboard} alt="img" /> */}
                      <i class="fa fa-dashboard"></i>
                      <span>Dashboard</span>
                    </Link>
                  </li>
                ) : null}

                {/* Accounting */}
                {
                  // checkUserPermission("/accounting") ||
                  checkUserPermission("/show-accounting-module") ? (
                    // checkUserPermission("/manage-account") ||
                    // checkUserPermission("/manage-account/:id") ||
                    // checkUserPermission("/delete-account") ||
                    // checkUserPermission("/bank-deposit") ||
                    // checkUserPermission("/transfer") ||
                    // checkUserPermission("/manage-transfer/:id") ||
                    // checkUserPermission("/manage-transfer") ||
                    // checkUserPermission("/journal-entry") ||
                    // checkUserPermission("/journal") ||
                    // checkUserPermission("/Expense") ||
                    // checkUserPermission("/task") ||
                    // checkUserPermission("/transaction-log") ||
                    // checkUserPermission("/view-register/:id") ||
                    // checkUserPermission("/account-report/:id") ||
                    // checkUserPermission("/manage-inactive-account")
                    <li className="submenu">
                      <a
                        className={
                          pathname.includes("/accounts") ||
                          pathname.includes("/accounting")
                            ? "active subdrop"
                            : "" || pathname.includes("/bank-deposit")
                            ? "active subdrop"
                            : "" || pathname.includes("/Expense")
                            ? "active subdrop"
                            : "" || pathname.includes("/transfer")
                            ? "active subdrop"
                            : "" || pathname.includes("/manage-transfer")
                            ? "active subdrop"
                            : "" || pathname.includes("/manage-transfer/:id")
                            ? "active subdrop"
                            : "" || pathname.includes("/journal-entry")
                            ? "active subdrop"
                            : "" || pathname.includes("/journals")
                            ? "active subdrop"
                            : "" || pathname.includes("/task")
                            ? "active subdrop"
                            : "" || pathname.includes("/quantity-adjustment")
                            ? "active subdrop"
                            : "" || pathname.includes("/manage-account")
                            ? "active subdrop"
                            : "" || pathname.includes("/manage-account/:id")
                            ? "active subdrop"
                            : "" || pathname.includes("/transaction-log")
                            ? "active subdrop"
                            : "" || pathname.includes("/view-register/:id")
                            ? "active subdrop"
                            : "" || pathname.includes("/paymentmethods")
                            ? "active subdrop"
                            : "" || pathname.includes("/account-report/:id")
                            ? "active subdrop"
                            : "" ||
                              pathname.includes("/manage-inactive-account")
                            ? "active subdrop"
                            : "" || isSideMenu == "accounts"
                            ? "subdrop active"
                            : ""
                        }
                        onClick={() =>
                          toggleSidebar(
                            isSideMenu == "accounts" ? "" : "accounts"
                          )
                        }
                      >
                        {/* <img src={Product} alt="img" /> */}
                        <i class="fa fa-bank"></i>
                        <span> Accounting </span>{" "}
                        <span className="menu-arrow" />
                      </a>
                      {isSideMenu == "accounts" ? (
                        <ul className="sidebar-ul">
                          {checkUserPermission("/accounting") ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("/accounting")
                                    ? "active"
                                    : "custome-active-padding"
                                }
                                to="/accounting"
                              >
                                Chart Of Account
                              </Link>
                            </li>
                          ) : null}

                          {checkUserPermission("/bank-deposit") ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("/bank-deposit")
                                    ? "active "
                                    : "custome-active-padding"
                                }
                                to="/bank-deposit"
                              >
                                Undeposited funds
                              </Link>
                            </li>
                          ) : null}

                          {/* {checkUserPermission("/transfer") ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("/transfer") ? "active" : ""
                                }
                                to="/transfer"
                              >
                                Transfer
                              </Link>
                            </li>
                          ) : null} */}
                          {checkUserPermission("/manage-transfer") ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("/transfer")
                                    ? "active"
                                    : "custome-active-padding"
                                }
                                to="/manage-transfer"
                              >
                                Add New Transfer
                              </Link>
                            </li>
                          ) : null}

                          {checkUserPermission("/journal-entry") ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("/journal-entry")
                                    ? "active"
                                    : "custome-active-padding"
                                }
                                to="/journal-entry"
                              >
                                Journal Entry
                              </Link>
                            </li>
                          ) : null}

                          {/* {checkUserPermission("/journal") ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("/journals") ? "active" : ""
                                }
                                to="/journals"
                              >
                                View Journal
                              </Link>
                            </li>
                          ) : null} */}

                          {/* {checkUserPermission("/ExpenseList") ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("/ExpenseList")
                                    ? "active"
                                    : ""
                                }
                                to="/ExpenseList"
                              >
                                Expense List
                              </Link>
                            </li>
                          ) : null} */}

                          {checkUserPermission("/Expense") ? (
                            <li
                              onClick={() =>
                                handleLinkClickManageReceivingExpence()
                              }
                            >
                              <Link
                                className={
                                  pathname.includes("/Expense")
                                    ? "active"
                                    : "custome-active-padding"
                                }
                                to="/Expense"
                                onClick={redirectToreceiving}
                              >
                                Expenses
                              </Link>
                            </li>
                          ) : null}

                          {/* {checkUserPermission("/task") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("/task") ? "active" : ""
                              }
                              to="/task"
                            >
                              Task
                            </Link>
                          </li>
                        ) : null} */}

                          {checkUserPermission("/quantity-adjustment") ? (
                            <li style={{ display: "none" }}>
                              <Link
                                className={
                                  pathname.includes("/quantity-adjustment")
                                    ? "active"
                                    : "custome-active-padding"
                                }
                                to="/quantity-adjustment"
                              >
                                Inventory Quantity Adjustment
                              </Link>
                            </li>
                          ) : null}
                          {checkUserPermission("/receiving-paybills") ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("paybills") ||
                                  pathname.includes("/paybills")
                                    ? "active"
                                    : "custome-active-padding"
                                }
                                to="/paybills"
                              >
                                Pay Bills
                              </Link>
                            </li>
                          ) : null}
                          {checkUserPermission("/receive-payment") ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("receive-payment") ||
                                  pathname.includes("/receive-payment")
                                    ? "active"
                                    : "custome-active-padding"
                                }
                                to="/receive-payment"
                              >
                                Receive Payments
                              </Link>
                            </li>
                          ) : null}

                          {checkUserPermission("/transaction-log") ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("transaction-log") ||
                                  pathname.includes("/transaction-log")
                                    ? "active"
                                    : "custome-active-padding"
                                }
                                to="/transaction-log"
                              >
                                Transaction Log
                              </Link>
                            </li>
                          ) : null}
                          {checkUserPermission("/paymentmethods") ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("paymentmethods") ||
                                  pathname.includes("/paymentmethods")
                                    ? "active"
                                    : "custome-active-padding"
                                }
                                to="/paymentmethods"
                              >
                                Payment Methods
                              </Link>
                            </li>
                          ) : null}

                          {checkUserPermission("/view-register/:id") && data.length > 0  ? (
                            <li>
                              <Link
                                className={
                                  pathname.includes("paymentmethods") ||
                                  pathname.includes("/paymentmethods")
                                    ? "active"
                                    : "custome-active-padding"
                                }
                                to={`/vregister/${data[0]?.Id}`}
                              >
                                Cash On Hand
                              </Link>
                            </li>
                          ) : null}
                        </ul>
                      ) : (
                        ""
                      )}
                    </li>
                  ) : null
                }

                {/* Inventory */}
                {checkUserPermission("/show-inventory") ? (
                  // checkUserPermission("/inventory") ||
                  // checkUserPermission("/tags") ||
                  // checkUserPermission("/manufacturers") ||
                  // checkUserPermission("/brand") ||
                  // checkUserPermission("/modifiers-list") ||
                  // checkUserPermission("/categories") ||
                  // checkUserPermission("/attributes") ||
                  // checkUserPermission("/items")
                  <li className="submenu">
                    <a
                      className={
                        pathname.includes("/inventory") ||
                        pathname.includes("/items")
                          ? "active subdrop"
                          : "" || pathname.includes("/item-Kits")
                          ? "active subdrop"
                          : "" || pathname.includes("/manage-item-Kits")
                          ? "active subdrop"
                          : "" || pathname.includes("/tags")
                          ? "active subdrop"
                          : "" || pathname.includes("/manage-Items")
                          ? "active subdrop"
                          : "" || pathname.includes("/modifiers-list")
                          ? "active subdrop"
                          : "" || pathname.includes("/modifiers-manage")
                          ? "active subdrop"
                          : "" || pathname.includes("/items-custom-fields")
                          ? "active subdrop"
                          : "" || pathname.includes("/categories")
                          ? "active subdrop"
                          : "" || pathname.includes("/manufacturers")
                          ? "active subdrop"
                          : "" || pathname.includes("/attributes")
                          ? "active subdrop"
                          : "" || pathname.includes("/manage-price-rules")
                          ? "active subdrop"
                          : "" || pathname.includes("/deleted-price-rules")
                          ? "active subdrop"
                          : "" || pathname.includes("/deleted-items")
                          ? "active subdrop"
                          : "" || pathname.includes("/brand")
                          ? "active subdrop"
                          : "" || pathname.includes("/inventory-stock-status")
                          ? "active subdrop"
                          : "" ||
                            pathname.includes(
                              "/inventory-stock-status-by-category"
                            )
                          ? "active subdrop"
                          : "" || isSideMenu == "inventory"
                          ? "subdrop active"
                          : ""
                      }
                      onClick={() =>
                        toggleSidebar(
                          isSideMenu == "inventory" ? "" : "inventory"
                        )
                      }
                    >
                      {/* <img src={Product} alt="img" /> */}
                      <i class="fas fa-box-open"></i>
                      <span> Inventory </span> <span className="menu-arrow" />
                    </a>
                    {isSideMenu == "inventory" ? (
                      <ul className="sidebar-ul">
                        {checkUserPermission("/items") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("items")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/items"
                            >
                              Items
                            </Link>
                          </li>
                        ) : null}

                        {/* {checkUserPermission("/item-Kits") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("item-Kits") ? "active" : ""
                              }
                              to="/item-Kits"
                            >
                              Item Kits
                            </Link>
                          </li>
                        ) : null} */}

                        {checkUserPermission("/tags") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("tags")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/tags"
                            >
                              Tags
                            </Link>
                          </li>
                        ) : null}

                        {/* {checkUserPermission("/modifiers-list") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("modifiers") ? "active" : ""
                              }
                              to="/modifiers-list"
                            >
                              Modifiers
                            </Link>
                          </li>
                        ) : null} */}

                        {checkUserPermission("/categories") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("categories")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/categories"
                            >
                              Categories
                            </Link>
                          </li>
                        ) : null}

                        {checkUserPermission("/manufacturers") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("manufacturers")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/manufacturers"
                            >
                              Manufacturers
                            </Link>
                          </li>
                        ) : null}

                        {checkUserPermission("/attributes") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("attributes")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/attributes"
                            >
                              Attributes
                            </Link>
                          </li>
                        ) : null}

                        {checkUserPermission("/brand") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("brand")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/brand"
                            >
                              Brand
                            </Link>
                          </li>
                        ) : null}

                        {checkUserPermission("/inventory-stock-status") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("inventory-stock-status")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/inventory-stock-status"
                            >
                              Inventory Stock Status
                            </Link>
                          </li>
                        ) : null}
                      </ul>
                    ) : (
                      ""
                    )}
                  </li>
                ) : null}

                {/* Promo Rule */}

                {checkUserPermission("/show-price-rule") ? (
                  // checkUserPermission("/promo-rule") ||
                  // checkUserPermission("/price-rules") ||
                  // checkUserPermission("/role-tier") ||
                  // checkUserPermission("/recall-price")
                  <li className="submenu">
                    <a
                      className={
                        pathname.includes("/promo-rule") ||
                        pathname.includes("/price-rules")
                          ? "active subdrop"
                          : "" || pathname.includes("/role-tier")
                          ? "active subdrop"
                          : "" || isSideMenu == "promo-rule"
                          ? "subdrop active"
                          : ""
                      }
                      onClick={() =>
                        toggleSidebar(
                          isSideMenu == "promo-rule" ? "" : "promo-rule"
                        )
                      }
                    >
                      {/* <img src={Product} alt="img" /> */}
                      <i class="fas fa-money-check-alt"></i>
                      <span> Pricing Rule </span>{" "}
                      <span className="menu-arrow" />
                    </a>

                    {isSideMenu == "promo-rule" ? (
                      <ul>
                        {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 583-596
                        {checkUserPermission("/price-rules") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("price-rules") ? "active" : ""
                              }
                              to="/price-rules"
                            >
                              Price Rules
                            </Link>
                          </li>
                        ) : null} */}

                        {checkUserPermission("/role-tier") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("role-tier")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/role-tier"
                            >
                              Role Tier
                            </Link>
                          </li>
                        ) : null}

                        {checkUserPermission("/promotion-price") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("promotion-price")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/promotion-price"
                            >
                              Promotion Price
                            </Link>
                          </li>
                        ) : null}

                        {checkUserPermission("/recall-price") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("recall-price")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/recall-price"
                            >
                              Recall Price
                            </Link>
                          </li>
                        ) : null}
                      </ul>
                    ) : (
                      ""
                    )}
                  </li>
                ) : null}

                {/* Inventory Stock Status */}
                {/* {checkUserPermission("/inventory-stock-status") ? (
                  <li
                    className={
                      pathname.includes("/inventory-stock-status") ||
                      pathname.includes("/inventory-stock-status-by-category")
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to="/inventory-stock-status"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      <i class="fas fa-list"></i>
                      <span>Public Inventory Stock Status</span>
                    </Link>
                  </li>
                ) : null} */}

                {/* Contacts */}

                {/* <li className="submenu">
                  <a
                    className={
                      pathname.includes("/contacts") ||
                      pathname.includes("/customers")
                        ? "active subdrop"
                        : "" || pathname.includes("/manage-customers")
                        ? "active subdrop"
                        : "" || pathname.includes("/deleted-customers")
                        ? "active subdrop"
                        : "" || pathname.includes("/customer-intake-form")
                        ? "active subdrop"
                        : "" || pathname.includes("/import-excel-customers")
                        ? "active subdrop"
                        : "" || pathname.includes("/customer-barcode-label")
                        ? "active subdrop"
                        : "" || pathname.includes("/custom-field-configuration")
                        ? "active subdrop"
                        : "" || isSideMenu == "contacts"
                        ? "subdrop active"
                        : ""
                    }
                    onClick={() =>
                      toggleSidebar(isSideMenu == "contacts" ? "" : "contacts")
                    }
                  >
                    <img src={Users1} alt="img" />
                    <span> Contacts </span> <span className="menu-arrow" />
                  </a>
                  {isSideMenu == "contacts" ? (
                    <ul className="sidebar-ul">
                      {checkUserPermission("/customers") ? (
                        <li>
                          <Link
                            className={
                              pathname.includes("customers") ? "active" : ""
                            }
                            to="/customers"
                          >
                            Customers
                          </Link>
                        </li>
                      ) : null}
                    </ul>
                  ) : (
                    ""
                  )}
                </li> */}

                {/*Customers*/}
                {checkUserPermission("/show-customer") ? (
                  <li
                    className={
                      pathname.includes("customers") ||
                      pathname.includes("/manage-customers") ||
                      pathname.includes("/deleted-customers") ||
                      pathname.includes("/customer-intake-form") ||
                      pathname.includes("/import-excel-customers") ||
                      pathname.includes("/customer-barcode-label") ||
                      pathname.includes("/custom-field-configuration")
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to="/customers"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img src={Users1} alt="img" /> */}

                      <i class="fas fa-user-alt"></i>
                      <span>Customers</span>
                    </Link>
                  </li>
                ) : null}

                {/*Suppliers*/}
                {checkUserPermission("/show-supplier") ? (
                  <li
                    className={
                      pathname.includes("suppliers") ||
                      pathname.includes("/manage-suppliers") ||
                      pathname.includes("/deleted-suppliers") ||
                      pathname.includes("/import-excel-suppliers") ||
                      pathname.includes("/custom-field-suppliers-configuration")
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to="/suppliers"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img
                        src={Suppliers}
                        alt="img"
                        style={{ width: "20px" }}
                      /> */}

                      {/* <i class="fas fa-user-alt"></i> */}
                      <i class="fas fa-user-friends"></i>
                      <span>Suppliers</span>
                    </Link>
                  </li>
                ) : null}

                {/* Receiving */}
                {/* {checkUserPermission("/receiving") ? (
                  <li
                    className={
                      pathname.includes("/receiving") ||
                        pathname.includes("/receiving-receipt") ||
                        pathname.includes("/receiving-barcode-label")
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to="/receiving"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      <img src={Receiving} alt="img" />
                      <span>Receiving</span>
                    </Link>
                  </li>
                ) : null} */}

                {checkUserPermission("/show-receving") ? (
                  // checkUserPermission("/receiving") ||
                  // checkUserPermission("/manage-receiving") ||
                  // checkUserPermission("/manage-receiving/:id") ||
                  // checkUserPermission("/receiving-paybills")
                  <li className="submenu">
                    <a
                      className={
                        pathname.includes("/receiving") ||
                        pathname.includes("/manage-receiving")
                          ? "active subdrop"
                          : "" || pathname.includes("/receiving-paybills")
                          ? "active subdrop"
                          : "" || pathname.includes("/receiving-barcode-label")
                          ? "active subdrop"
                          : "" || isSideMenu == "receiving"
                          ? "subdrop active"
                          : ""
                      }
                      onClick={() =>
                        toggleSidebar(
                          isSideMenu == "receiving" ? "" : "receiving"
                        )
                      }
                    >
                      {/* <img src={Sales1} alt="img" /> */}
                      <i class="fa fa-shopping-cart"></i>
                      <span> Receiving </span> <span className="menu-arrow" />
                    </a>
                    {isSideMenu == "receiving" ? (
                      <ul className="sidebar-ul">
                        {checkUserPermission("/receiving") && (
                          <li>
                            <Link
                              className={
                                pathname.includes("receiving") ||
                                pathname.includes("/receiving")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/receiving"
                            >
                              Receiving List
                            </Link>
                          </li>
                        )}
                        {(checkUserPermission("/manage-receiving") ||
                          checkUserPermission("/pos-receiving")) && (
                          <li onClick={() => handleLinkClickManageReceiving()}>
                            <Link
                              className={
                                pathname.includes("manage-receiving") ||
                                pathname.includes("/manage-receiving")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              // to="/manage-receiving"
                              to={
                                isManageReceiving == 1
                                  ? "/manage-receiving"
                                  : isManagePOSReceiving == 1
                                  ? "/pos-receiving"
                                  : "#"
                              }
                            >
                              Add New Receiving
                            </Link>
                          </li>
                        )}
                        {checkUserPermission("/receiving-paybills") && (
                          <li>
                            <Link
                              className={
                                pathname.includes("paybills") ||
                                pathname.includes("/paybills")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/paybills"
                            >
                              Pay Bills
                            </Link>
                          </li>
                        )}
                        {/* {checkUserPermission("/receiving-expenses") && (
                          <li>
                            <Link
                              className={
                                pathname.includes("receiving-expenses") ||
                                pathname.includes("/receiving-expenses")
                                  ? "active"
                                  : ""
                              }
                              to="/receiving-expenses"
                            >
                              Advance Bill Pay
                            </Link>
                          </li>
                        )} */}

                        {checkUserPermission("/receiving-receipt/:id") ? (
                          <li>
                            <Link
                              // type="button"
                              className="dropdown-item"
                              data-bs-target="#LookupReceiptModal"
                              data-bs-toggle="modal"
                            >
                              {/* <i className="far fa-file fs-6 me-1"></i> */}
                              Lookup Receipt
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}
                      </ul>
                    ) : (
                      ""
                    )}
                  </li>
                ) : null}

                {/* Sales */}
                {/* {checkUserPermission("/sales") ? (
                  <li className={pathname.includes("sales") || pathname.includes("/sales") ? "active" : ""}>
                    <Link
                      to="/sales"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      <img src={Sales1} alt="img" />
                      <span>Sales</span>
                    </Link>
                  </li>
                ) : null} */}

                {checkUserPermission("/show-sale") ? (
                  // checkUserPermission("/sales") ||
                  // checkUserPermission("/receive-payment") ||
                  // checkUserPermission("/sales-receipt") ||
                  // checkUserPermission("/ecom-orders")
                  <li className="submenu">
                    <a
                      className={
                        pathname.includes("/sales") ||
                        pathname.includes("/manage-sales") ||
                        pathname.includes("/receive-payment") ||
                        pathname.includes("/ecom-orders")
                          ? "active subdrop"
                          : "" || pathname.includes("/receive-payment")
                          ? "active subdrop"
                          : "" || pathname.includes("/ecom-orders")
                          ? "active subdrop"
                          : "" || isSideMenu == "sales"
                          ? "subdrop active"
                          : ""
                      }
                      onClick={() =>
                        toggleSidebar(isSideMenu == "sales" ? "" : "sales")
                      }
                    >
                      {/* <img src={Sales1} alt="img" /> */}
                      <i class="fa fa-shopping-bag"></i>
                      <span> Sales </span> <span className="menu-arrow" />
                    </a>
                    {isSideMenu == "sales" ? (
                      <ul className="sidebar-ul">
                        {checkUserPermission("/sales") && (
                          <li>
                            <Link
                              className={
                                pathname.includes("sales") ||
                                pathname.includes("/sales")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/sales"
                            >
                              Sales List
                            </Link>
                          </li>
                        )}
                        {/* {checkUserPermission("/manage-sales") && ( */}
                        <li onClick={() => handleLinkClickManageSales()}>
                          <Link
                            className={
                              pathname.includes("manage-sales") ||
                              pathname.includes("/manage-sales")
                                ? "active"
                                : "custome-active-padding"
                            }
                            // to="/manage-sales"
                            to={
                              isManageSale == 1
                                ? "/manage-sales"
                                : isManagePOSSale == 1 && regId > 0
                                ? "/pos"
                                : isManagePOSSale == 1 &&
                                  regId == 0 &&
                                  showEmployeeRegister == "true"
                                ? "/posregister?type=create"
                                : "/pos"
                            }
                          >
                            Add New Sale
                          </Link>
                        </li>
                        {/* )} */}
                        {/* {checkUserPermission("/manage-sales") && (
                          <li onClick={() => handleLinkClickManageSales()}>
                            <Link
                              className={
                                pathname.includes("manage-sales") ||
                                pathname.includes("/manage-sales")
                                  ? "active"
                                  : ""
                              }
                              // to="/manage-sales"
                              to={
                                isManageSale == 1
                                  ? "/manage-sales"
                                  : isManagePOSSale == 1
                                  ? "/pos"
                                  : "#"
                              }
                            >
                              Add New Sale
                            </Link>
                          </li>
                        )} */}
                        {checkUserPermission("/receive-payment") && (
                          <li>
                            <Link
                              className={
                                pathname.includes("receive-payment") ||
                                pathname.includes("/receive-payment")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/receive-payment"
                            >
                              Receive Payments
                            </Link>
                          </li>
                        )}
                        {checkUserPermission("/ecom-orders") && (
                          <li>
                            <Link
                              className={
                                pathname.includes("ecom-orders") ||
                                pathname.includes("/ecom-orders")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/ecom-orders"
                            >
                              Ecom Order List
                            </Link>
                          </li>
                        )}
                        {checkUserPermission(PERMISSION_LOOKUPRECEIPT) && (
                          <li>
                            <Link
                              className="dropdown-item"
                              data-bs-target="#LookupReceiptSaleModal"
                              data-bs-toggle="modal"
                            >
                              Lookup Receipt
                            </Link>
                          </li>
                        )}
                      </ul>
                    ) : (
                      ""
                    )}
                  </li>
                ) : null}

                {/* GiftCard */}
                {/* <li className={pathname.includes("giftcard") ? "active" : ""}>
                  <Link
                    to="/giftcard"
                    onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                  >
                    <img src={GiftCard} alt="img" style={{ width: "18px" }} />
                    <span>Gift Cards</span>
                  </Link>
                </li> */}

                {/* Delivery  */}
                {checkUserPermission("/Driver-Task-List") ||
                checkUserPermission("/Driver-Daily-sheet") ? (
                  <li className="submenu">
                    <a
                      className={
                        pathname.includes("/Driver-Task-List") ||
                        pathname.includes("/Driver-Daily-sheet") ||
                        pathname.includes("/Driver-Task-Receipt/:id") ||
                        isSideMenu == "Delivery"
                          ? // pathname.includes("/receive-payment") ||
                            // pathname.includes("/ecom-orders")
                            "active subdrop"
                          : ""
                      }
                      onClick={() =>
                        toggleSidebar(
                          isSideMenu == "Delivery" ? "" : "Delivery"
                        )
                      }
                    >
                      {/* <img src={Sales1} alt="img" /> */}
                      <i class="fa fa-shopping-bag"></i>
                      <span> Delivery </span> <span className="menu-arrow" />
                    </a>
                    {isSideMenu == "Delivery" ? (
                      <ul className="sidebar-ul">
                        {checkUserPermission("/Driver-Daily-sheet") && (
                          <li>
                            <Link
                              className={
                                pathname.includes("/Driver-Daily-sheet")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/Driver-Daily-sheet"
                            >
                              Driver Daily Sheet
                            </Link>
                          </li>
                        )}
                        {checkUserPermission("/Driver-Task-List") && (
                          <li onClick={() => handleLinkClickManageSales()}>
                            <Link
                              className={
                                pathname.includes("/Driver-Task-List")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/Driver-Task-List"
                            >
                              Driver Task List
                            </Link>
                          </li>
                        )}
                        {checkUserPermission("/Driver-Task-Receipt/:id") && (
                          <li>
                            <Link
                              className={
                                ""
                                // pathname.includes("receive-payment") ||
                                // pathname.includes("/receive-payment")
                                //   ? "active"
                                //   : ""
                              }
                              data-bs-target="#LookupReceiptDriverTaskModel"
                              data-bs-toggle="modal"
                              // to="/receive-payment"
                            >
                              Driver Task LookUp Receipt
                            </Link>
                          </li>
                        )}
                      </ul>
                    ) : (
                      ""
                    )}
                  </li>
                ) : null}

                {/* <li>
                  <Link  onClick={ handlepaymnetmethod}>
                    <i class="fa fa-bank"></i>
                    <span>Pull Payment Method</span>
                  </Link>
                </li> */}

                {/* Employees  */}
                {/* {checkUserPermission("/show-employee") ? (
                  <li
                    className={
                      pathname.includes("/employees") ||
                      pathname.includes("/manage-employee") ||
                      pathname.includes(
                        "/custom-field-employee-configuration"
                      ) ||
                      pathname.includes("/manage-permissions")
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to="/employees"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      <i class="fas fa-user-tie"></i>
                      <span>Employees</span>
                    </Link>
                  </li>
                ) : null} */}

                {checkUserPermission("/show-employee") ? (
                  // checkUserPermission("/locations") ||
                  // checkUserPermission("/manage-locationrack")
                  <li className="submenu">
                    <a
                      className={
                        pathname.includes("/employees") ||
                        pathname.includes("/manage-employee")
                          ? "active subdrop"
                          : "" ||
                            pathname.includes(
                              "/custom-field-employee-configuration"
                            )
                          ? "active subdrop"
                          : "" || isSideMenu == "employees"
                          ? "subdrop active"
                          : ""
                      }
                      onClick={() =>
                        toggleSidebar(
                          isSideMenu == "employees" ? "" : "employees"
                        )
                      }
                    >
                      {/* <img src={Places} alt="img" /> */}
                      <i class="fas fa-user-tie"></i>
                      <span> Employees </span> <span className="menu-arrow" />
                    </a>
                    {isSideMenu == "employees" ? (
                      <ul className="sidebar-ul">
                        {/* Locations */}
                        {checkUserPermission("/employees") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("employees") ||
                                pathname.includes("/employees")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/employees"
                            >
                              Employees
                            </Link>
                          </li>
                        ) : null}

                        {/* Locations Rack Management */}
                        {checkUserPermission("/master-register") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("master-register") ||
                                pathname.includes("/master-register")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/master-register"
                            >
                              Master Registers
                            </Link>
                          </li>
                        ) : null}
                      </ul>
                    ) : (
                      ""
                    )}
                  </li>
                ) : null}

                {/* Appointment  */}
                {/* {checkUserPermission("/appointments") ? (
                  <li
                    className={
                      pathname.includes("appointments") ||
                      pathname.includes("/new-appointment")
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to="/appointments"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img src={calendar} alt="img" style={{ width: "18px" }} /> */}

                {/* <i class="fas fa-calendar-alt"></i>
                      <span>Appointments</span>
                    </Link>
                  </li>
                ) : null}  */}

                {checkUserPermission("/show-location") ? (
                  // checkUserPermission("/locations") ||
                  // checkUserPermission("/manage-locationrack")
                  <li className="submenu">
                    <a
                      className={
                        pathname.includes("/locations") ||
                        pathname.includes("/manage-locations")
                          ? "active subdrop"
                          : "" || pathname.includes("/manage-locationrack")
                          ? "active subdrop"
                          : "" || isSideMenu == "locations"
                          ? "subdrop active"
                          : ""
                      }
                      onClick={() =>
                        toggleSidebar(
                          isSideMenu == "locations" ? "" : "locations"
                        )
                      }
                    >
                      {/* <img src={Places} alt="img" /> */}
                      <i class="fas fa-map-marker-alt"></i>
                      <span> Locations </span> <span className="menu-arrow" />
                    </a>
                    {isSideMenu == "locations" ? (
                      <ul className="sidebar-ul">
                        {/* Locations */}
                        {checkUserPermission("/locations") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("locations") ||
                                pathname.includes("/locations")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/locations"
                            >
                              Locations
                            </Link>
                          </li>
                        ) : null}

                        {/* Locations Rack Management */}
                        {checkUserPermission("/manage-locationrack") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("manage-locationrack") ||
                                pathname.includes("/manage-locationrack")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/manage-locationrack"
                            >
                              Locations Rack Management
                            </Link>
                          </li>
                        ) : null}

                        {
                          // {checkUserPermission("/manage-locationrack") ? (
                          <li>
                            <Link
                              className={
                                pathname.includes("locations") ||
                                pathname.includes("/sub-company-list")
                                  ? "active"
                                  : "custome-active-padding"
                              }
                              to="/sub-company-list"
                            >
                              Sub company
                            </Link>
                          </li>
                        }
                      </ul>
                    ) : (
                      ""
                    )}
                  </li>
                ) : null}

                {/* Locations */}
                {/* {checkUserPermission("/locations") ? (
                  <li
                    className={pathname.includes("locations") ? "active" : ""}
                  >
                    <Link
                      to="/locations"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      <img src={Home} alt="img" />
                      <span>Locations</span>
                    </Link>
                  </li>
                ) : null} */}

                {/* Locations Rack Management */}
                {/* {checkUserPermission("/manage-locationrack") ? (
                  <li
                    className={
                      pathname.includes("/manage-locationrack") ? "active" : ""
                    }
                  >
                    <Link
                      to="/manage-locationrack"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      <img src={Places} alt="img" />
                      <span>Locations Rack Management</span>
                    </Link>
                  </li>
                ) : null} */}

                {/* StoreConfig Route  */}
                {checkUserPermission("show-store-config") ? (
                  <li
                    className={pathname.includes("storeconfig") ? "active" : ""}
                  >
                    <Link
                      to="/storeconfig"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img src={settings} alt="img" /> */}

                      <i class="fa fa-gear"></i>
                      <span>Store Config</span>
                    </Link>
                  </li>
                ) : null}

                {/* WorkOrders Route  */}
                {checkUserPermission("/workorders") ? (
                  <></>
                ) : // <li
                //   className={
                //     pathname.includes("workorders") ||
                //       pathname.includes("/editworkorder") ||
                //       pathname.includes("/workorder-barcode-label") ||
                //       pathname.includes("/manage-workorder-delete") ||
                //       pathname.includes("/manage-workorder-emailtemplates")
                //       ? "active"
                //       : ""
                //   }
                // >
                //   <Link
                //     to="/workorders"
                //     onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                //   >
                //     <img src={Wrench} alt="img" />
                //     <span>Work Orders</span>
                //   </Link>
                // </li>
                null}

                {/* Email Template Routes */}
                {checkUserPermission("show-email-templates") ? (
                  <li
                    className={
                      pathname.includes("email-templates") ||
                      pathname.includes("/email-template")
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to="/email-templates"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img src={Email} alt="img" style={{ width: "18px" }} /> */}
                      <i class="fa fa-envelope"></i>
                      <span>Email Templates</span>
                    </Link>
                  </li>
                ) : null}

                {/* EcommConfig Routes */}
                {checkUserPermission("show-ecom-config") ? (
                  <li
                    className={
                      pathname.includes("ecommconfig") ||
                      pathname.includes("/ecommconfig")
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to="/ecommconfig"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img src={Email} alt="img" style={{ width: "18px" }} /> */}
                      <i class="fa fa-envelope-open"></i>
                      <span>Ecomm Config</span>
                    </Link>
                  </li>
                ) : null}

                {checkUserPermission("show-ecom-user") ? (
                  <li
                    className={
                      pathname.includes("ecommusers") ||
                      pathname.includes("/ecommusers")
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to="/ecommusers"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img src={Users1} alt="img" style={{ width: "18px" }} /> */}

                      <i class="fa fa-user"></i>
                      <span>
                        Ecomm Users(
                        {pendingEcommCustomer?.PendingEcomCustomerCount})
                      </span>
                    </Link>
                  </li>
                ) : null}

                {/* Report */}

                {checkUserPermission("show-report") ? (
                  <li
                    className={
                      pathname.includes("report") ||
                      pathname.includes("/report")
                        ? // pathname.includes("/Customer-Balance-Summary") ||
                          // pathname.includes("/expense-report") ||
                          // pathname.includes("/customer-contact-list") ||
                          // pathname.includes("/sales-by-customer-detail") ||
                          // pathname.includes("/sales-by-customer-type-detail") ||
                          // pathname.includes("/transaction-list-by-customer")  ||
                          // pathname.includes("/sales-by-customer-summary-report") ||
                          // pathname.includes("/vendor-balance-summary") ||
                          // pathname.includes("/expenses-by-vendor-summary") ||
                          // pathname.includes("/open-purchase-order-list") ||
                          // pathname.includes("/transaction-list-by-vendor")
                          "active"
                        : ""
                    }
                  >
                    <Link
                      to="/reports"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img src={Sales1} alt="img" /> */}

                      <i class="fa fa-file-text"></i>
                      <span>Reports</span>
                    </Link>
                  </li>
                ) : null}

                {checkUserPermission("/quickbooksync") ? (
                  <li
                    className={
                      pathname.includes("quickbooksync") ||
                      pathname.includes("/quickbooksync")
                        ? "active"
                        : ""
                    }
                  >
                    <Link
                      to="/quickbooksync"
                      onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img src={Users1} alt="img" style={{ width: "18px" }} /> */}
                      {/* <i class="fa fa-user"></i> */}
                      <i class="fas fa-sync"></i>
                      <span>Integrations</span>
                    </Link>
                  </li>
                ) : null}

                {checkUserPermission("") ? (
                  <li className={"" ? "active" : ""}>
                    <Link
                      to="/dashboard"
                      // onClick={() => toggleSidebar(isSideMenu == "" ? "" : "")}
                    >
                      {/* <img src={Users1} alt="img" style={{ width: "18px" }} /> */}

                      <i class="fa fa-gear"></i>
                      <span>Sonar POS Version 1.0.1</span>
                    </Link>
                  </li>
                ) : null}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      <LookupReceiptSaleModal />
      <LookupReceiptModal />
      <LookupReceiptDriverTaskModel />
    </>
  );
};

export default Sidebar;
